import React from 'react';
import { Book } from 'src/components/Book/Book';
import { EndBar } from 'src/components/EndBar/EndBar';
import { useDialog } from 'src/components/providers/DialogProvider';
import { DataTestIds } from 'src/config/dataTestIds';
import useDashboard from 'src/hooks/useDashboard';
import Dashboard from 'src/screens/Dashboard';
import withTranslation from 'src/staticProps/withTranslation';
import InternalTemplate from 'src/templates/InternalTemplate';
const Page = () => {
  const {
    person,
    personSummary,
    supplementaryInsurance,
    appointments,
    recommendations,
    isLoading
  } = useDashboard({
    onlyRefetch: false
  });
  const dialog = useDialog();
  return /*#__PURE__*/React.createElement(InternalTemplate, {
    Prefooter: !dialog.dialogType ? /*#__PURE__*/React.createElement(EndBar, null, /*#__PURE__*/React.createElement(Book, {
      dataTestId: DataTestIds.DashboardBook
    })) : undefined
  }, /*#__PURE__*/React.createElement(Dashboard, {
    supplementaryInsurance: supplementaryInsurance,
    person: person,
    personSummary: personSummary,
    recommendations: recommendations,
    appointments: appointments,
    isLoading: isLoading
  }));
};
export const getStaticProps = withTranslation;
export default Page;